import Avatar from 'components/Avatar'
import AwardsIconWork from 'components/icons/AwardsIconWork'
import {
  GreyText,
  SecondGreyText,
  SecondaryHeading,
  StyledP,
  SubFLex,
} from 'modules/Roles/Partials/ViewCollegeDetails/Partials/ViewStudentDrawer/Partials/StudentDrawerContent/Style/style'
import React from 'react'
import { COLORS } from 'theme'

const HonorsAwardsSection = ({
  title,
  organization,
  awarded_on,
  description,
}) => {
  return (
    <SubFLex column gap="25px">
      <SubFLex gap="12px">
        <div>
          <Avatar
            background="none"
            src={''}
            size={48}
            icon={<AwardsIconWork />}
            boxShadow={true}
            padding="5px"
          />
        </div>
        <SubFLex column style={{ width: '90%' }}>
          <SecondaryHeading>{title}</SecondaryHeading>
          <SecondGreyText marginBottom="20px">{organization}</SecondGreyText>

          <GreyText color={COLORS.GREY_T_60}>{awarded_on}</GreyText>

          <StyledP
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          />
        </SubFLex>
      </SubFLex>
    </SubFLex>
  )
}

export default HonorsAwardsSection
